(function () {
  var BP_SP_MAX = 749;
  var BP_PC_MIN = 990;

  var q = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (match) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[match];
    });
  };

  var truncate = function (value, length) {
    var text = String(value == null ? '' : value);
    if (text.length <= length) return text;
    return text.slice(0, Math.max(0, length - 3)) + '...';
  };

  var isNew = function (publishedAt) {
    if (!publishedAt) return false;
    var published = new Date(publishedAt).getTime();
    if (Number.isNaN(published)) return false;
    var elapsedDays = (Date.now() - published) / (1000 * 60 * 60 * 24);
    return elapsedDays >= 0 && elapsedDays < 30;
  };

  var parseData = function (scriptEl) {
    if (!scriptEl) return [];
    try {
      var parsed = JSON.parse(scriptEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  var fetchPage = function (url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parseData(doc.querySelector('[data-aw-style-grid-data]'));
      })
      .catch(function () {
        return [];
      });
  };

  var cardHtml = function (item, favoriteIcons, hideMeta) {
    var media = '<img class="aw-style-card__image" src="' + esc(item.image) + '" width="' + (item.imageWidth || '') + '" height="' + (item.imageHeight || '') + '" loading="lazy" alt="' + esc(item.imageAlt || item.title) + '">';
    var badge = isNew(item.publishedAt) ? '<span class="aw-style-card__new">NEW</span>' : '';
    var length = item.length ? '<p class="aw-style-card__length">' + esc(item.length) + '</p>' : '';
    var favoriteIconsHtml = '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--outline">' + (favoriteIcons.outline || '') + '</span>' +
      '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--fill">' + (favoriteIcons.fill || '') + '</span>';
    var favorite = item.handle
      ? '<button type="button" class="aw-style-card__favorite" data-aw-favorite-button data-favorite-type="style" data-favorite-handle="' + esc(item.handle) + '" data-favorite-url="' + esc(item.url) + '" data-favorite-title="' + esc(item.title) + '" data-favorite-image="' + esc(item.image) + '" data-favorite-image-alt="' + esc(item.imageAlt || item.title) + '" data-favorite-meta="' + esc(item.length) + '" aria-pressed="false" aria-label="お気に入りに追加">' + favoriteIconsHtml + '</button>'
      : '';
    var topRow = (length || favorite) ? '<div class="aw-style-card__top-row">' + length + favorite + '</div>' : '';
    var title = item.title ? '<h3 class="aw-style-card__title">' + esc(item.title) + '</h3>' : '';
    var excerpt = item.stylePoint ? '<p class="aw-style-card__excerpt">' + esc(truncate(item.stylePoint, 42)) + '</p>' : '';
    var salon = (!hideMeta && item.salon) ? '<p class="aw-style-card__salon">' + esc(item.salon) + '</p>' : '';
    var staff = (!hideMeta && item.staff) ? '<p class="aw-style-card__staff">' + esc(item.staff) + '</p>' : '';
    var meta = (salon || staff) ? '<div class="aw-style-card__meta">' + salon + staff + '</div>' : '';
    var body = '<div class="aw-style-card__body">' + topRow + title + excerpt + meta + '</div>';
    var tag = item.url ? 'a' : 'div';
    var href = item.url ? ' href="' + esc(item.url) + '"' : '';
    var linkClass = item.url ? ' aw-link-hover' : '';

    return '<' + tag + ' class="aw-style-card' + linkClass + '"' + href + '>' +
      '<div class="aw-style-card__image-wrap">' + media + badge + '</div>' +
      body +
      '</' + tag + '>';
  };

  var maxItemsFor = function (root) {
    var width = window.innerWidth;
    if (width >= BP_PC_MIN) return Number(root.dataset.perPagePc) || 5;
    if (width <= BP_SP_MAX) return Number(root.dataset.perPageSp) || 6;
    return Number(root.dataset.perPageTb) || 6;
  };

  function initStyleGrid(root) {
    var grid = q('[data-aw-style-grid-target]', root);
    if (!grid) return;

    var items = parseData(q('[data-aw-style-grid-data]', root));
    var totalPages = Number(root.dataset.sourcePages || 1);
    var pageParam = root.dataset.sourcePageParam || 'page';
    var filterKey = root.dataset.filterKey || 'salonHandle';
    var filterValue = root.dataset.filterValue || '';
    var sortBy = root.dataset.sortBy === 'published_at' ? 'published_at' : 'display_order';
    var hideMeta = root.dataset.hideMeta === 'true';
    var favoriteIcons = {
      outline: root.dataset.favoriteIconSvg || '',
      fill: root.dataset.favoriteIconFillSvg || ''
    };

    var sortItems = function (list) {
      var copy = list.slice();
      if (sortBy === 'published_at') {
        copy.sort(function (a, b) {
          var aTime = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
          var bTime = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
          if (Number.isNaN(aTime)) aTime = 0;
          if (Number.isNaN(bTime)) bTime = 0;
          return bTime - aTime;
        });
        return copy;
      }
      copy.sort(function (a, b) {
        return Number(a.displayOrder || 999999) - Number(b.displayOrder || 999999);
      });
      return copy;
    };

    var render = function () {
      var matched = sortItems(items.filter(function (item) {
        return !!item.image && item[filterKey] === filterValue;
      }));

      var visible = matched.slice(0, maxItemsFor(root));
      if (!visible.length) {
        root.hidden = true;
        grid.innerHTML = '';
        return;
      }

      grid.innerHTML = visible.map(function (item) { return cardHtml(item, favoriteIcons, hideMeta); }).join('');
      root.hidden = false;

      if (window.awFavorites) window.awFavorites.init(grid);
    };

    var loadRemainingPages = function () {
      if (totalPages <= 1) return Promise.resolve();
      var base = new URL(window.location.href);
      base.searchParams.delete(pageParam);
      var jobs = [];
      for (var page = 2; page <= totalPages; page++) {
        var pageUrl = new URL(base);
        pageUrl.searchParams.set(pageParam, page);
        jobs.push(fetchPage(pageUrl.toString()));
      }
      return Promise.all(jobs).then(function (pages) {
        pages.forEach(function (pageItems) {
          items = items.concat(pageItems);
        });
      });
    };

    // Paint matching cards immediately from server-rendered data.
    // Continue loading the remaining pages without blocking the first display.
    render();

    loadRemainingPages().then(function () {
      var seen = {};
      items = items.filter(function (item) {
        var handle = item.handle || '';
        if (handle && seen[handle]) return false;
        if (handle) seen[handle] = true;
        return true;
      });

      window.awStyleItems = items;
      document.dispatchEvent(new CustomEvent('aw:style-items-loaded', { detail: { items: items } }));

      render();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(render, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-style-grid]'), initStyleGrid);
  });
})();
